{
  "nav": {
    "chat": "Sessione",
    "agents": "Agenti",
    "history": "Cronologia",
    "files": "File",
    "changes": "Modifiche",
    "mailbox": "Posta",
    "skills": "Skill",
    "worktrees": "Worktree",
    "design": "Design Studio",
    "officemap": "Mappa uffici",
    "settings": "Impostazioni",
    "sddwizard": "Nuovo progetto SDD",
    "specs": "Specifiche",
    "sddboard": "Bacheca live",
    "autophase": "Fasi",
    "fleet": "Flotta",
    "inspector": "Ispettore",
    "prompts": "Prompt"
  },
  "brand": {
    "returnToChat": "{{name}} — torna alla chat",
    "returnToChatDefault": "WrongStack — torna alla chat"
  },
  "status": {
    "connected": "Connesso",
    "disconnected": "Disconnesso",
    "idle": "Inattivo",
    "thinking": "In riflessione",
    "running": "In esecuzione",
    "waiting": "In attesa",
    "done": "Completato",
    "stopped": "Fermato"
  },
  "menu": {
    "moreWithHidden": "Altro, {{count}} elementi nascosti",
    "moreOptions": "Altre opzioni",
    "moreCompactHidden": "Altro — {{count}} pannelli/viste nascosti, palette, tema, monitor",
    "moreCompact": "Altro — palette, tema, monitor",
    "moreFull": "Altro — palette, tema, scorciatoie, monitor",
    "commandPalette": "Palette dei comandi",
    "keyboardShortcuts": "Scorciatoie da tastiera",
    "panels": "Pannelli",
    "views": "Viste",
    "theme": "Tema",
    "monitors": "Monitor",
    "fleetMonitor": "Monitor della flotta",
    "agentsMonitor": "Monitor degli agenti"
  },
  "sidePanel": {
    "dragHint": "Trascina per ridimensionare · doppio clic per ripristinare",
    "collapse": "Comprimi pannello (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Apri dashboard delle sessioni"
  },
  "agents": {
    "pending": "in attesa…",
    "empty": "Nessun agente",
    "emptyHint": "I sotto-agenti appaiono qui quando la flotta è attiva.",
    "runningCount": "{{count}} in esecuzione",
    "totalCount": "{{count}} totali",
    "openFull": "Apri vista agenti completa",
    "agentsLive": "AGENTI · LIVE",
    "doneCount": "{{count}} completati",
    "failedCount": "{{count}} falliti",
    "modelsLabel": "modelli",
    "shownLabel": "mostrati",
    "totalLabel": "totale",
    "leaderFleetTotals": "(leader {{leader}} · flotta {{fleet}})",
    "navHintJk": "j/k o ↑↓ per navigare",
    "escCloseDetail": "· Esc per chiudere il dettaglio",
    "noAgentsRunning": "Nessun agente in corso.",
    "contextUsage": "Utilizzo contesto",
    "lastToolLabel": "ultimo:",
    "unknownSession": "Sessione sconosciuta",
    "sessionCopyTitle": "Sessione: {{sid}} — clicca per copiare",
    "sessionWord": "sessione",
    "agentsCountSuffix_one": "{{count}} agente",
    "agentsCountSuffix_other": "{{count}} agenti",
    "sessionTitle": "Sessione: {{sid}}",
    "projectSuffix": " · Progetto: {{name}}",
    "statusIdle": "inattivo"
  },
  "changes": {
    "fileCount_one": "{{count}} file",
    "fileCount_other": "{{count}} file",
    "refreshTitle": "Aggiorna modifiche",
    "loading": "Caricamento modifiche…",
    "clean": "Nessuna modifica — l'albero di lavoro è pulito.",
    "selectPrompt": "Seleziona un file modificato per vederne il diff.",
    "unified": "Unificato",
    "unifiedTitle": "Diff unificato",
    "edit": "Modifica",
    "editTitle": "Diff side-by-side modificabile",
    "loadingDiff": "Caricamento diff…",
    "binary": "File binario — diff non mostrato.",
    "tooLarge": "File troppo grande per il diff."
  },
  "inspector": {
    "showPanel": "Mostra pannello Ispettore (Flotta / Agenti / Audit)",
    "hidePanel": "Nascondi pannello Ispettore",
    "label": "Ispettore",
    "openAudit": "Apri scheda Audit",
    "tabFleet": "Flotta",
    "tabAgents": "Agenti",
    "tabAudit": "Audit",
    "collapseAria": "Comprimi pannello Ispettore",
    "collapseTitle": "Comprimi (Esc)",
    "noAgentsActive": "Nessun agente attivo",
    "agentsAppearHint": "Gli agenti appaiono qui quando la flotta è attiva.",
    "selected": "{{name}} (selezionato)"
  },
  "nextSteps": {
    "header": "Prossimi passi",
    "autoSubmitting": "invio automatico tra",
    "clickToFill": "clic per compilare",
    "clickToFillTitle": "Clic per compilare: {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Invio automatico dopo il countdown"
  },
  "mailbox": {
    "onlineCount": "{{count}} online",
    "messages": "Messaggi",
    "deleteAllTitle": "Elimina tutti i messaggi",
    "deleteAll": "Elimina tutti",
    "deleting": "Eliminazione…",
    "purgeTitle": "Purga messaggi obsoleti/orfani",
    "purge": "Purga",
    "purging": "Purga in corso…",
    "newLabel": "NUOVO",
    "empty": "Nessun messaggio.",
    "offlineCount": "+{{count}} offline",
    "timeNow": "ora",
    "deleteAllConfirmTitle_one": "Eliminare {{count}} messaggio?",
    "deleteAllConfirmTitle_other": "Eliminare tutti i {{count}} messaggi?",
    "deleteAllConfirmBody": "Il file della mailbox viene troncato per ogni agente. Operazione irreversibile.",
    "purgeConfirmTitle": "Purgare i messaggi obsoleti?",
    "purgeConfirmBody": "Rimuove i messaggi completati più vecchi di 1 giorno e quelli incompleti più vecchi di 7 giorni. I messaggi attivi vengono conservati.",
    "type": {
      "note": "Nota",
      "ask": "Domanda",
      "assign": "Assegnazione",
      "steer": "Dirigi",
      "btw": "A proposito",
      "broadcast": "Broadcast",
      "status": "Stato",
      "result": "Risultato"
    },
    "emptyDetail": "Nessun messaggio selezionato",
    "emptyDetailHint": "Clicca un messaggio nel pannello Mailbox per vederlo qui.",
    "readBy": "Letto da",
    "backToChat": "Torna alla chat",
    "completed": "Completato",
    "everyone": "tutti",
    "closeTitle": "Chiudi (Esc)",
    "replyTo": "In risposta a: {{id}}",
    "completedBy": "Completato da {{name}}",
    "completedByAt": "Completato da {{name}} il {{time}}",
    "outcome": "Risultato:",
    "task": "Attività:",
    "messageNotFound": "Messaggio non trovato",
    "messageNotFoundHint": "Questo messaggio potrebbe essere stato eliminato o rimosso."
  },
  "sessions": {
    "recentSessions": "Sessioni recenti",
    "deleteEmptyTitle_one": "Eliminare {{count}} sessione vuota?",
    "deleteEmptyTitle_other": "Eliminare {{count}} sessioni vuote?",
    "deleteEmptyConfirmBody": "Le sessioni senza utilizzo di token vengono rimosse dal disco.",
    "filterPlaceholder": "Filtra per titolo, modello, provider…",
    "clearFilter": "Cancella filtro",
    "noHistory": "Nessuna cronologia",
    "noHistoryHint": "Le tue conversazioni appariranno qui",
    "noMatches": "Nessuna corrispondenza",
    "noMatchesHint": "Prova un filtro diverso",
    "group": {
      "favorites": "Preferiti",
      "today": "Oggi",
      "yesterday": "Ieri",
      "thisWeek": "Questa settimana",
      "earlier": "Precedenti"
    },
    "nicknamePlaceholder": "Soprannome",
    "empty": "(vuoto)",
    "resuming": "riprende…",
    "active": "attiva",
    "renameTitleNickname": "{{nickname}} — originale: {{title}}",
    "renameTitle": "{{title}}\n\nDoppio clic per rinominare",
    "unfavorite": "Rimuovi dai preferiti",
    "markFavorite": "Segna come preferito",
    "deleteSessionConfirmTitle": "Eliminare la sessione?",
    "deleteSessionConfirmBody": "\"{{name}}\" verrà rimossa dal disco. Operazione irreversibile.",
    "deleteSessionTitle": "Elimina sessione"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Interrompi",
      "newSession": "Nuova sessione",
      "export": "Esporta",
      "compact": "Comprimi",
      "newSessionTitle": "Avvia una nuova sessione (Ctrl+N)",
      "exportTitle": "Esporta la chat come markdown (Ctrl+E)",
      "compactTitle": "Comprimi la finestra di contesto",
      "clearTitle": "Cancella il contesto (Ctrl+L)"
    },
    "model": "Modello",
    "modelTitle": "Cambia modello (Ctrl+M)",
    "context": "Contesto",
    "contextTitle": "Clicca per un dettaglio del contesto",
    "sessionLabel": "Sessione",
    "stats": {
      "messages": "Messaggi",
      "elapsed": "Trascorso",
      "tokens": "Token",
      "cost": "Costo",
      "iteration": "Iterazione",
      "agents": "Agenti",
      "tokensSub": "{{in}} in / {{out}} out",
      "iterationOf": "di {{max}}",
      "agentsRunning": "{{count}} in esecuzione"
    },
    "plan": "Piano",
    "planComplete": "{{pct}}% completato",
    "pinned": "Fissati",
    "quickSettings": "Impostazioni rapide",
    "autonomy": "Autonomia",
    "autonomyOptions": {
      "off": "Off",
      "suggest": "Suggerisci",
      "auto": "Auto",
      "eternal": "Perpetuo",
      "eternal-parallel": "Perpetuo Parallelo"
    },
    "yolo": "Modalità YOLO",
    "yoloTitle": "Ignora le conferme degli strumenti",
    "refine": "Affina i prompt",
    "refineTitle": "Riscrivi i prompt prima dell'invio",
    "sound": "Suono al completamento",
    "soundTitle": "Riproduci un dolce suono al termine di un'esecuzione",
    "sessionId": "sessione {{id}}"
  },
  "fleet": {
    "status": {
      "running": "in esecuzione",
      "done": "completato",
      "failed": "fallito",
      "timeout": "timeout",
      "stopped": "fermato"
    },
    "leader": "leader",
    "providerModel": "Provider / Modello",
    "elapsed": "Trascorso",
    "running": "in corso…",
    "iterations": "Iterazioni",
    "toolCalls": "Chiamate strum.",
    "cost": "Costo",
    "budgetExtensions": "Estensioni budget",
    "activity": "Attività",
    "budgetWarning": "avviso budget",
    "contextWindow": "Finestra di contesto",
    "tokensUsed": "{{used}} / {{max}} token",
    "toolRunning": "in esecuzione…",
    "lastTool": "ultimo strumento",
    "error": "Errore",
    "finalOutput": "Output finale",
    "copyOutput": "Copia output",
    "liveOutput": "Output live",
    "waitingOutput": "In attesa di output…",
    "outputHint": "L'output appare qui mentre l'agente trasmette il testo.",
    "toolLog": "Log strumenti ({{count}} chiamate)",
    "fail": "fallito",
    "moreTools": "+{{count}} altri strumenti",
    "cardRunning": "in esecuzione {{tool}}",
    "cardLastTool": "ultimo: {{tool}}",
    "contextPercent": "Contesto {{pct}}%",
    "doneCount": "{{count}} completati",
    "errCount": "{{count}} err",
    "statusRunning": "in corso",
    "statusDone": "completato",
    "statusFailed": "fallito",
    "statusTimeout": "timeout",
    "statusStopped": "fermato",
    "sessionPrefix": "sessione:",
    "currentTask": "Attività corrente",
    "performance": "Prestazioni",
    "uniqueTools": "Strumenti unici",
    "avgPerTool": "media {{ms}}ms per strumento",
    "context": "Contesto",
    "tokens": "Token",
    "ctxUsed": "{{pct}}% usato",
    "completed": "completato",
    "budgetWarningTitle": "⚡ Avviso budget",
    "hittingLimit": "Raggiunge il limite {{kind}} ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ raggiunge il limite {{kind}} ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} estensione budget",
    "budgetExt_other": "{{count}} estensioni budget",
    "extendedTimes_one": "L'agente ha esteso il budget {{count}} volta per attività lunghe",
    "extendedTimes_other": "L'agente ha esteso il budget {{count}} volte per attività lunghe",
    "errorLabel": "Errore",
    "failureReason": "Motivo fallimento",
    "failed": "Fallito",
    "fleetMonitor": "MONITOR FLOTTA",
    "runningCount": "{{count}} in corso",
    "totalAgents_one": "{{count}} agente in totale",
    "totalAgents_other": "{{count}} agenti in totale",
    "noLeader": "nessun leader",
    "closeFleet": "Chiudi monitor flotta",
    "colName": "Nome",
    "colStatus": "Stato",
    "colActivity": "Attività",
    "colIters": "Iter.",
    "colTools": "Strum.",
    "colCost": "Costo",
    "colCtx": "CTX",
    "colExt": "Est.",
    "colReason": "Motivo",
    "noAgentsActive": "Nessun agente attivo",
    "agentsAppear": "Gli agenti appaiono qui quando la flotta è attiva.",
    "agentTimeline": "Cronologia agenti",
    "noAgentEvents": "Nessun evento di conversazione agente ancora.",
    "navHint": "↑↓ naviga",
    "selectDetailHint": "↵ seleziona dettaglio",
    "escHint": "Esc deseleziona / chiudi",
    "detailedView": "vista dettagliata",
    "closeBtn": "✕ chiudi",
    "selectAgentDetail": "Seleziona un agente per informazioni dettagliate",
    "selectAgentBody": "Clicca un agente della lista per metriche dettagliate, log strumenti, output in streaming e altro — simile alla vista dettagliata della cronologia chat.",
    "navigateWord": "naviga",
    "selectWord": "seleziona",
    "deselectWord": "deseleziona"
  },
  "context": {
    "wsNotConnected": "WebSocket non connesso",
    "noData": "Nessun dato di debug ricevuto. Il server potrebbe non supportare il debug del contesto.",
    "title": "Dettaglio contesto",
    "windowUsage": "Utilizzo finestra",
    "contextMode": "Modalità contesto",
    "fetching": "Recupero del dettaglio del contesto…",
    "systemPrompt": "Prompt di sistema",
    "tools": "Strumenti",
    "messages": "Messaggi",
    "tokenAllocation": "Allocazione token",
    "systemTitle": "Sistema: {{tokens}}",
    "toolsTitle": "Strumenti: {{tokens}}",
    "messagesTitle": "Messaggi: {{tokens}}",
    "system": "Sistema",
    "toolBreakdown": "Dettaglio strumenti",
    "messagesSummary": "Messaggi ({{count}}) — {{total}} tok",
    "barWithTokens": "Finestra di contesto: {{tokens}} / {{max}} token ({{pct}})",
    "barPct": "Finestra di contesto: {{pct}}",
    "barClick": " — clicca per il dettaglio"
  },
  "refine": {
    "header": "✨ Affina prompt",
    "autoSend": "invio automatico in {{count}} s",
    "cancelTitle": "Annulla (Esc)",
    "editLabel": "Modifica il prompt affinato:",
    "editPlaceholder": "Modifica il prompt affinato...",
    "useEdit": "Usa modifica",
    "original": "Originale",
    "refined": "Affinato",
    "yourLanguage": "(la tua lingua)",
    "refinedTitle": "Clicca o premi Invio per usare questa versione",
    "english": "Inglese",
    "englishTitle": "Premi e per la versione inglese",
    "hintRefined": "affinato",
    "hintEnglish": "Inglese",
    "hintOriginal": "originale",
    "hintEdit": "modifica",
    "edit": "Modifica",
    "useRefined": "Usa affinato"
  },
  "specs": {
    "heading": "Specifiche",
    "subtitle": "Visualizza e gestisci lo sviluppo guidato dalle specifiche",
    "empty": "Nessuna spec trovata. Usa {{command}} per crearne una.",
    "tasks": "Attività ({{count}})",
    "doneCount": "{{count}} completate",
    "runningCount": "{{count}} in corso",
    "pendingCount": "{{count}} in attesa",
    "runTitle": "Esegui questa spec come una bacheca AutoPhase live",
    "run": "Esegui",
    "list": "Lista",
    "graph": "Grafo",
    "loadingTasks": "Caricamento attività…"
  },
  "refresh": {
    "heading": "Verificatore di resilienza F5",
    "subtitle": "Conferma che l'ultima sessione attiva, la trascrizione e lo stato UI sopravvivono a un aggiornamento della pagina. Apri questa vista, poi premi F5 — ogni riga verde dovrebbe restare verde.",
    "recordProbe": "Registra sondaggio",
    "latestSession": "Ultima sessione attiva",
    "restoredLocal": "Ripristinato da localStorage",
    "sessionIdExtra": "id sessione: {{id}}",
    "noSessionYet": "nessuna sessione è ancora stata avviata",
    "activePointer": "Puntatore sessione attiva",
    "lastVisited": "timestamp lastVisitedAt",
    "never": "mai",
    "persistedEnv": "Ambiente persistente",
    "transcriptRehydrate": "Reidratazione trascrizione chat",
    "localTranscript": "Trascrizione locale recuperata",
    "messagesExtra": "{{count}} messaggi, {{queued}} in coda",
    "noMessages": "0 messaggi",
    "noBleed": "Nessuna perdita tra sessioni",
    "bleedExtra": "collegato={{bound}} vs attivo={{active}}",
    "transcriptBinds": "la trascrizione si lega alla sessione attiva",
    "uiWorkspace": "Area di lavoro UI",
    "noneValue": "(nessuno)",
    "payloadSize": "Carico utile localStorage (4 chiavi): {{count}} caratteri",
    "probeLog": "Registro sondaggi",
    "noProbes": "Nessun sondaggio ancora — premi il pulsante \"Registra sondaggio\" in alto, oppure F5 in questa vista, per registrare un controllo di reidratazione.",
    "simulatedF5": "F5 simulato: riesecuzione di persist rehydrate"
  },
  "board": {
    "status": {
      "pending": "In attesa",
      "in_progress": "In corso",
      "review": "Revisione",
      "failed": "Fallito",
      "completed": "Completato",
      "queued": "In coda",
      "blocked": "Bloccato",
      "cancelled": "Annullato"
    },
    "newTaskTitle": "Nuova attività",
    "newTaskPlaceholder": "Titolo attività…",
    "addTask": "Aggiungi attività",
    "empty": "Nessuna fase ancora — avvia un'esecuzione AutoPhase per popolare la bacheca.",
    "summary": "{{phases}} fasi · {{tasks}} attività",
    "phases": "Fasi",
    "statusTab": "Stato",
    "dropHere": "Trascina le attività qui",
    "emptySpec": "Nessuna attività in questa spec ancora.",
    "depGraphHeading": "Grafo delle dipendenze",
    "worktreePrefix": "worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "In aumento",
    "trendDown": "In diminuzione",
    "trendStable": "Stabile",
    "heading": "Dashboard di debug",
    "subtitle": "Monitoraggio in tempo reale per WrongStack WebUI",
    "refreshLabel": "Aggiorna:",
    "lastUpdated": "Ultimo aggiornamento: {{time}}",
    "fetchFailed": "Recupero delle metriche non riuscito",
    "fileWatcher": "File Watcher",
    "watcherStatus": "Stato watcher",
    "running": "In esecuzione",
    "stopped": "Fermo",
    "activeProjects": "Progetti attivi",
    "projectsWatched": "Progetti monitorati",
    "fileChanges": "Modifiche file",
    "totalDetected": "Totale rilevato",
    "filesProcessed": "File elaborati",
    "afterHash": "Dopo filtro hash",
    "broadcastsSent": "Broadcast inviati",
    "toClients": "Ai client WebUI",
    "debounceResets": "Reset debounce",
    "rapidWrites": "Scritture rapide successive",
    "avgDebounce": "Ritardo debounce medio",
    "actualDelay": "Ritardo effettivo applicato",
    "totalDelay": "Ritardo totale",
    "sumDelays": "Somma di tutti i ritardi",
    "browserPerf": "Prestazioni browser",
    "heapUsed": "Heap usato",
    "jsHeap": "Heap JavaScript",
    "heapTotal": "Heap totale",
    "totalHeap": "Dimensione totale heap",
    "pageUptime": "Tempo di attività pagina",
    "sinceLoad": "Dal caricamento",
    "rawData": "Dati grezzi"
  },
  "providerModels": {
    "using": "In uso",
    "noModelPicked": "(nessun modello scelto)",
    "clearAllowlist": "Cancella allowlist",
    "clearAllowlistAria": "Cancella l'allowlist salvata per {{provider}}",
    "refresh": "Aggiorna dal server",
    "refreshAria": "Aggiorna l'elenco modelli per {{provider}}",
    "probing": "Verifica…",
    "use": "Usa",
    "useModelAria": "Usa il modello {{model}} per {{provider}}",
    "differsHint": "L'elenco verificato differisce dall'allowlist salvata — riesegui {{command}} per rendere permanente."
  },
  "dock": {
    "expandChip": "Espandi {{label}}",
    "collapseChip": "Comprimi {{label}}",
    "ahead": "{{count}} in avanti",
    "behind": "{{count}} indietro",
    "linesAdded": "{{count}} righe aggiunte",
    "linesDeleted": "{{count}} righe eliminate",
    "untrackedFiles": "{{count}} file non tracciati",
    "customizeTitle": "Personalizza chip del dock",
    "dockChips": "Chip del dock",
    "noActiveGoal": "Nessun obiettivo attivo",
    "noActiveGoalDetail": "Avvia un obiettivo dalla chat o dal comando goal."
  },
  "agentsMonitor": {
    "leaderBadge": "LEADER",
    "iters": "Iter.",
    "tools": "Strumenti",
    "activityBins": "Attività (12 bin)",
    "streamingOutput": "Output in streaming",
    "recentTools": "Strumenti recenti",
    "finalOutput": "Output finale",
    "heading": "Monitor agenti",
    "prevAgent": "Agente precedente",
    "nextAgent": "Agente successivo",
    "closeAria": "Chiudi monitor agenti",
    "hintPage": "←→ pagina",
    "hintNavigate": "↑↓ naviga elenco",
    "hintEsc": "Esc chiudi"
  },
  "terminal": {
    "resize": "Ridimensiona terminali",
    "labelSingular": "Terminale",
    "labelPlural": "Terminali",
    "projectShell": "Shell del progetto",
    "maxTerminals": "Massimo {{count}} terminali",
    "newTerminal": "Nuovo terminale",
    "restart": "Riavvia terminale attivo",
    "closeAll": "Chiudi tutti i terminali",
    "closeDock": "Chiudi dock del terminale (Ctrl+`)",
    "closeTab": "Chiudi {{name}}",
    "processExited": "[processo terminato con codice {{code}}]"
  },
  "sessionWatch": {
    "liveStream": "Stream dal vivo",
    "events_one": "{{count}} evento",
    "events_other": "{{count}} eventi",
    "interruptTitle": "Ferma cooperativamente questo agente al prossimo passo (non un kill)",
    "interrupt": "⏸ Interrompi",
    "interrupting": "…",
    "loading": "Caricamento sessione…",
    "done": "✓✓ fatto",
    "read": "✓ letto",
    "delivered": "⏳ consegnato",
    "agent": "Agente",
    "you": "Tu",
    "working": "{{name}} · in lavoro",
    "claude": "Claude",
    "priority": "Priorità",
    "placeholder": "{{label}} → questa sessione…",
    "send": "Invia",
    "sendHint": "⌘/Ctrl+Invio per inviare · visibile alla prossima iterazione dell'agente",
    "msgType": {
      "steerLabel": "🔄 Dirigi",
      "steerHint": "Regola il comportamento durante l'attività",
      "askLabel": "❓ Chiedi",
      "askHint": "Domanda — attende una risposta",
      "assignLabel": "📋 Assegna",
      "assignHint": "Un'attività da svolgere",
      "noteLabel": "💬 Nota",
      "noteHint": "Per info, non urgente"
    },
    "sentRunning": "Consegnato — l'agente in esecuzione lo vedrà al prossimo passo",
    "sentIdle": "Consegnato — il target è inattivo; appare nella sua mailbox, letto alla prossima esecuzione",
    "sentFailed": "Non riuscito: {{error}}",
    "interruptReason": "L'operatore ha richiesto l'arresto da Fleet HQ",
    "interruptSent": "Interruzione inviata — l'agente si ferma al prossimo passo (non un kill)",
    "interruptFailed": "Interruzione non riuscita: {{error}}"
  },
  "sideEffects": {
    "empty": "Nessun effetto collaterale registrato ancora.",
    "emptyHint": "I comandi bash, le installazioni di pacchetti e le richieste di rete appariranno qui.",
    "heading": "Effetti collaterali",
    "exportTitle": "Esporta gli effetti collaterali filtrati come CSV",
    "all": "Tutti",
    "colTime": "Ora",
    "colTool": "Strumento",
    "colRisk": "Rischio",
    "colDetail": "Dettaglio",
    "colOutcome": "Esito"
  },
  "monitor": {
    "elapsedHm": "{{h}}h {{m}}m fa",
    "elapsedMs": "{{m}}m {{s}}s fa",
    "elapsedS": "{{s}}s fa",
    "heading": "Monitor della flotta",
    "clientsHeading": "Client connessi",
    "terminal": "Terminale",
    "webui": "UI Web",
    "repl": "REPL",
    "totalConnected": "connessi in totale",
    "mailQueue": "Coda di posta",
    "total": "Totale",
    "open": "Aperti",
    "unread": "Non letti",
    "agents": "Agenti",
    "messagesSub": "messaggi",
    "uncompletedSub": "non completati",
    "waitingSub": "in attesa",
    "ofTotal": "su {{count}} totali",
    "agentRoster": "Elenco agenti",
    "liveMailActivity": "Attività posta dal vivo",
    "noActivity": "Nessuna attività recente",
    "mailboxAgents": "Agenti mailbox",
    "noMailboxAgents": "Nessun agente registrato",
    "moreCount": "+{{count}} altri",
    "agentFallback": "agente",
    "fleetAgents": "Agenti flotta",
    "noFleetAgents": "Nessun agente flotta in esecuzione",
    "iter": "iter.",
    "mailType": {
      "sent": "Inviato",
      "delivered": "Consegnato",
      "read": "Letto",
      "completed": "Completato"
    }
  },
  "sdd": {
    "status": {
      "pending": "in attesa",
      "queued": "in coda",
      "in_progress": "in corso",
      "blocked": "bloccato",
      "review": "revisione",
      "failed": "fallito",
      "completed": "completato",
      "cancelled": "annullato"
    },
    "activityHeading": "Attività",
    "feedEmpty": "Ancora nulla — gli eventi appaiono qui man mano che gli agenti prendono e completano le attività.",
    "destroyTitle": "Distruggere il progetto SDD?",
    "destroyDesc": "Questo cancella il run e il suo lavoro. Non può essere annullato (il revert opzionale preserva la cronologia).",
    "stopRun": "Ferma il run",
    "stopRunAgents_one": "Ferma il run ({{count}} agente attivo)",
    "stopRunAgents_other": "Ferma il run ({{count}} agenti attivi)",
    "removeWorktreesAll": "Rimuovi tutti i worktree git + branch wstack/ap/* — incluso il lavoro non mergiato",
    "removeWorktreesCount_one": "Rimuovi {{count}} worktree git + branch wstack/ap/* — incluso il lavoro non mergiato",
    "removeWorktreesCount_other": "Rimuovi {{count}} worktree git + branch wstack/ap/* — incluso il lavoro non mergiato",
    "deleteArtifacts": "Elimina tutti gli artefatti SDD (spec, grafo attività, board, sessione)",
    "revertMerged_one": "Revert anche {{count}} commit mergiato",
    "revertMerged_other": "Revert anche {{count}} commit mergiati",
    "revertHint": "Aggiunge commit di revert (cronologia preservata). Rifiutato se l'albero di lavoro è sporco.",
    "baseBranchFallback": "il branch di base",
    "noteLeaveMerged": "I commit mergiati resteranno sul branch di base. Spunta la casella sopra per annullare anche quelli.",
    "noteAbandon": "Assicurati di voler davvero abbandonare questo run.",
    "destroying": "Distruzione…",
    "destroyAll": "Distruggi tutto",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Pronto",
    "kanbanRunning": "In corso",
    "kanbanReview": "Revisione",
    "kanbanFailed": "Fallito",
    "kanbanDone": "Completato",
    "kanbanEmpty": "vuoto"
  },
  "toolResult": {
    "collapseToLines": "Comprimi alle prime {{count}} righe",
    "showAllLines": "Mostra tutte le {{total}} righe ({{more}} in più)",
    "exitCode": "codice di uscita:",
    "jsonLines": "JSON · {{count}} righe",
    "collapse": "comprimi",
    "expand": "espandi"
  },
  "design": {
    "heading": "Design Studio — Galleria",
    "kitsCount": "{{count}} kit",
    "searchPlaceholder": "Cerca kit…",
    "stackTitle": "Stack per Use + Materialize",
    "wrote": "Scritto {{path}}",
    "materializeFailed": "Materialize non riuscito: {{error}}",
    "verifyError": "Verifica: {{error}}",
    "verifyOffPalette": "Verifica: {{pct}}% on-palette — {{count}} off-palette in {{files}} file",
    "verifyClean": "Verifica: pulito ✓ ({{files}} file on-palette)",
    "writing": "Scrittura del file di tema…",
    "scanning": "Scansione dei file UI…",
    "active": "Attivo",
    "reapply": "Riapplica",
    "use": "Usa",
    "materializeTitle": "Scrivi i token in un file di tema {{stack}}",
    "materialize": "Materializza",
    "verifyTitle": "Scansiona i file UI per colori fuori palette",
    "verify": "Verifica",
    "colors": "Colori"
  },
  "autoPhase": {
    "summary_one": "{{count}} fase · {{pct}}% completato",
    "summary_other": "{{count}} fasi · {{pct}}% completato",
    "switchBoard": "Cambia bacheca",
    "boardsCount_one": "{{count}} bacheca…",
    "boardsCount_other": "{{count}} bacheche…",
    "toggleAutonomousTitle": "Attiva/disattiva modalità autonoma",
    "autonomous": "Autonomo",
    "manual": "Manuale",
    "resumeTitle": "Riprendi l'esecuzione",
    "pauseTitle": "Sospendi l'esecuzione",
    "resume": "Riprendi",
    "pause": "Sospendi",
    "stopTitle": "Ferma l'esecuzione — annulla immediatamente gli agenti in corso",
    "stop": "Ferma",
    "newTitle": "Cancella questa bacheca e avvia una nuova esecuzione AutoPhase",
    "newLabel": "Nuovo",
    "revertConfirm": "Annullare i commit dell'esecuzione?",
    "revertTitle": "Annulla questa esecuzione — git-revert dei commit effettuati e rimozione dei worktree",
    "revert": "Annulla",
    "goal": "Obiettivo",
    "planning": "Pianificazione delle fasi…",
    "planningBody": "Il tuo obiettivo è stato ricevuto. WrongStack lo sta scomponendo in fasi e attività — la bacheca appare qui appena il piano è pronto.",
    "startHeading": "Avvia un piano di fasi",
    "startBody": "Descrivi cosa vuoi costruire. WrongStack pianificherà fasi e attività, poi le eseguirà — osserva e guida l'esecuzione sulla bacheca.",
    "startPlaceholder": "es. Crea un'API REST per la gestione utenti con Express e SQLite...",
    "isolateLabel": "Isola ogni fase nel suo worktree git",
    "startButton": "Avvia AutoPhase",
    "ctrlHint": "Ctrl+Invio per avviare",
    "isolateOn": "le fasi girano in worktree isolati, uniti in squash",
    "isolateOff": "le fasi girano direttamente sul ramo corrente",
    "lanes": "Corsie",
    "graph": "Grafo",
    "planningAck": "🚀 **AutoPhase** — ricevuto. Sto pianificando le fasi per il tuo obiettivo…"
  },
  "collab": {
    "noObservers": "Nessun osservatore dal vivo",
    "observerTitle": "Entra come osservatore in sola lettura (Fase 1)",
    "observerRole": "osservatore",
    "annotatorTitle": "Entra come annotatore — lascia note sugli strumenti (Fase 2)",
    "annotatorRole": "annotatore",
    "controllerTitle": "Entra come controllore — può mettere in pausa l'agente (Fase 3)",
    "controllerRole": "controllore",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "chiudi",
    "observers_one": "{{count}} osservatore",
    "observers_other": "{{count}} osservatori",
    "annotationsTitle": "{{count}} annotazione/i aperte — annotatori in revisione",
    "notes_one": "{{count}} nota",
    "notes_other": "{{count}} note",
    "pausedTitle": "Ciclo agente in pausa — un controllore sta revisionando",
    "paused": "in pausa",
    "joinedTitle": "Entrato {{time}}",
    "grantTitle": "Cedi controllo — promuovi questo partecipante a controllore",
    "injectTitle": "Inietta un risultato sintetico per una chiamata strumento in corso",
    "inject": "Inietta",
    "resumeTitle": "Riprendi il ciclo dell'agente",
    "resume": "Riprendi",
    "pauseTitle": "Metti in pausa l'agente prima della prossima chiamata strumento",
    "pauseAgent": "Metti in pausa agente",
    "leaveTitle": "Lascia la sessione di osservazione",
    "leave": "Lascia",
    "injectToolResult": "Inietta risultato strumento",
    "close": "chiudi",
    "targetTool": "id tool_use target",
    "targetPlaceholder": "scegli una chiamata in corso o digita un id tool_use",
    "toolFallback": "strumento",
    "noPendingTools": "Nessuna chiamata strumento in corso — digita un id tool_use o metti prima in pausa l'agente.",
    "resultContent": "Contenuto risultato",
    "resultPlaceholder": "Risultato strumento sintetico fornito all'agente al posto dell'esecuzione",
    "markError": "segna come errore",
    "reasonPlaceholder": "motivo (registro audit)",
    "queueInjection": "Metti in coda iniezione",
    "controllerInjection": "iniezione controllore"
  },
  "connection": {
    "reconnecting": "Riconnessione al backend (tentativo {{attempt}}) — nuovo tentativo tra {{remaining}} s",
    "disconnected": "Disconnesso dal backend",
    "retry": "Riprova ora",
    "retryTitle": "Riprova la connessione ora",
    "dismissTitle": "Chiudi (il chip nella barra superiore mostra ancora lo stato)"
  },
  "mode": {
    "modePrefix": "modalità:",
    "activeTitle": "Modalità attiva",
    "heading": "Modalità",
    "defaultName": "Predefinito",
    "defaultDesc": "Comportamento standard dell'agente"
  },
  "cost": {
    "clickTitle": "Clicca per il dettaglio dei costi per turno",
    "heading": "Dettaglio costi",
    "noPricing": "Nessuna tariffazione per il modello attuale — i valori di costo sono zero.",
    "noTurns": "Nessun turno completato ancora. Esegui un prompt per vedere il costo per turno qui.",
    "topExpensive_one": "Turno più costoso",
    "topExpensive_other": "I {{count}} turni più costosi"
  },
  "model": {
    "runDefault": "Predefinito del run",
    "useRunDefault": "Usa predefinito del run",
    "filterPlaceholder": "Filtra modelli…",
    "loading": "Caricamento modelli…",
    "noMatch": "Nessuna corrispondenza"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Filtra provider e modelli…",
    "noSavedProviders": "Nessun provider salvato — registra prima una chiave nelle Impostazioni.",
    "active": "attivo"
  },
  "work": {
    "todos": "Da fare",
    "tasks": "Attività",
    "plan": "Piano"
  },
  "todos": {
    "toggleAria": "Attiva/disattiva: {{content}}",
    "removeTitle": "Rimuovi attività",
    "removeAria": "Rimuovi \"{{content}}\"",
    "completedCount_one": "{{count}} completata",
    "completedCount_other": "{{count}} completate"
  },
  "task": {
    "start": "Avvia",
    "complete": "Completa",
    "retry": "Riprova",
    "assign": "Assegna",
    "assignTitle": "Assegna agente",
    "unassigned": "Non assegnato",
    "statusPending": "In attesa",
    "statusInProgress": "In corso",
    "statusBlocked": "Bloccato",
    "statusFailed": "Fallito",
    "statusReview": "Revisione",
    "statusDone": "Completato",
    "startTitle": "Avvia",
    "completeTitle": "Completa",
    "fail": "Fallisci",
    "failTitle": "Segna come fallito",
    "boardCount": "{{total}} attività · {{done}} completate"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} chiamata strumento",
    "toolCalls_other": "{{count}} chiamate strumento"
  },
  "fileRef": {
    "removeTitle": "Rimuovi riferimento",
    "linesCount_one": "{{count}} riga",
    "linesCount_other": "{{count}} righe"
  },
  "plan": {
    "statusOpen": "Aperto",
    "statusInProgress": "In corso",
    "statusDone": "Completato",
    "startTitle": "Avvia",
    "doneTitle": "Segna come completato",
    "reopenTitle": "Riapri",
    "reopen": "Riapri"
  },
  "filePicker": {
    "heading": "@ File",
    "noMatch": "Nessun file corrisponde a \"{{query}}\"",
    "searching": "Ricerca nel progetto…"
  },
  "toast": {
    "dismiss": "Chiudi"
  },
  "search": {
    "placeholder": "Cerca nella chat…",
    "prevHit": "Risultato precedente",
    "nextHit": "Risultato successivo",
    "close": "Chiudi (Esc)"
  },
  "phase": {
    "statusPending": "In attesa",
    "statusReady": "Pronto",
    "statusRunning": "In esecuzione",
    "statusPaused": "In pausa",
    "statusCompleted": "Completato",
    "statusFailed": "Fallito",
    "statusSkipped": "Saltato",
    "heading": "Fasi",
    "autonomousOn": "● Autonomo",
    "autonomousOff": "○ Manuale",
    "autonomousOnTitle": "Modalità autonoma attiva — clicca per mettere in pausa",
    "autonomousOffTitle": "Modalità manuale — clicca per attivare l'autonomo",
    "overallProgress": "Progresso complessivo",
    "tasksSuffix": "{{done}}/{{total}} attività",
    "agentsSuffix_one": "{{count}} agente",
    "agentsSuffix_other": "{{count}} agenti"
  },
  "ctxMode": {
    "triggerTitle": "Modalità finestra di contesto",
    "ctxPrefix": "ctx:",
    "opsHeading": "Operazioni di contesto",
    "compactNow": "Compatta ora",
    "compactNowDesc": "Ometti output strumento vecchi",
    "compactAggressive": "Compattazione aggressiva",
    "compactAggressiveDesc": "Omissione massima ora",
    "repairContext": "Ripara contesto",
    "repairDesc": "Correggi blocchi tool-use orfani",
    "debugContext": "Debug contesto",
    "debugDesc": "Dettaglio dimensioni per sezione",
    "windowHeading": "Finestra di contesto",
    "keepElide": "mantieni {{k}} recenti · ometti {{t}}+ token",
    "fallbackName": "Bilanciato",
    "fallbackDesc": "Compattazione rolling predefinita"
  },
  "transcript": {
    "kindAssistant": "Assistente",
    "kindThinking": "Pensiero",
    "kindToolCall": "Chiamata strumento",
    "kindToolResult": "Risultato strumento",
    "kindError": "Errore",
    "kindStatus": "Stato",
    "kindSystem": "Sistema",
    "title": "Cronologia chat",
    "copyTitle": "Copia cronologia chat agente",
    "empty": "Nessuna cronologia chat per questo agente ancora."
  },
  "autonomy": {
    "heading": "Modalità autonomia",
    "titlePrefix": "Autonomia: {{label}}",
    "descOff": "Controllo manuale totale — l'agente attende il tuo input.",
    "descSuggest": "L'agente suggerisce i prossimi passi ma attende approvazione.",
    "descAuto": "L'agente procede automaticamente dopo un breve ritardo di conferma.",
    "descEternal": "L'agente gira in autonomia fino al completamento dell'obiettivo.",
    "descEternalParallel": "Esecuzione autonoma multi-agente — modalità flotta."
  },
  "queue": {
    "heading": "Coda dei messaggi",
    "subtitle": "{{count}} in coda · messaggi inviati prima che l'agente finisca",
    "btwTitle": "A proposito — inviato come follow-up senza interrompere l'agente in corso",
    "steerTitle": "Guida — interrompe l'agente in corso e lo reindirizza con questo messaggio",
    "queueTitle": "In coda — trattenuto fino al completamento del run dell'agente, poi inviato in ordine",
    "sortNewestTitle": "Ordinato dal più recente — clicca per ordinare dal più vecchio",
    "sortOldestTitle": "Ordinato dal più vecchio — clicca per ordinare dal più recente",
    "newest": "Più recente",
    "oldest": "Più vecchio",
    "clear": "Svuota",
    "clearTitle": "Cancella tutti i messaggi in coda",
    "closeTitle": "Chiudi",
    "emptyTitle": "La coda è vuota",
    "emptyBody": "Usa i pulsanti btw / steer / aggiungi a coda accanto all'input per aggiungere messaggi. Gli elementi in coda sono inviati in ordine al completamento del run dell'agente.",
    "removeTitle": "Rimuovi dalla coda",
    "footer": "I messaggi sono inviati in ordine di arrivo al completamento del run dell'agente. Usa l'ordinamento per vedere i più recenti prima."
  },
  "checkpoint": {
    "heading": "Checkpoint di sessione",
    "countSuffix_one": "{{count}} checkpoint",
    "countSuffix_other": "{{count}} checkpoint",
    "description": "Riavvolgi la sessione a qualsiasi checkpoint. Messaggi e modifiche ai file tornano a quel punto — l'LLM continua da lì come se nulla fosse successo dopo.",
    "emptyTitle": "Nessun checkpoint ancora",
    "emptyBody": "I checkpoint sono creati automaticamente a ogni messaggio inviato. Invia qualche messaggio e torna.",
    "latest": "recente",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msg",
    "footerPre": "Clicca un checkpoint per riavvolgere",
    "footerPost": "per chiudere"
  },
  "goal": {
    "statusActive": "Attivo",
    "statusPaused": "In pausa",
    "statusDone": "Completato",
    "statusFailed": "Fallito",
    "statusAbandoned": "Abbandonato",
    "heading": "Obiettivo",
    "refined": "Raffinato",
    "progress": "Progresso",
    "iterations": "iterazioni",
    "deliverables": "Deliverable",
    "recentActivity": "Attività recente"
  },
  "worktree": {
    "cleanTitle_one": "Pulire {{count}} worktree orfano?",
    "cleanTitle_other": "Pulire {{count}} worktree orfani?",
    "cleanMessage": "Rimuove forzatamente ogni worktree git + branch wstack/ap residuo da run precedenti. Il lavoro non mergiato al loro interno va perso.",
    "cleanConfirm": "Pulisci orfani",
    "orphanCount_one": "{{count}} worktree orfano da run precedenti",
    "orphanCount_other": "{{count}} worktree orfani da run precedenti",
    "andMore": "…e {{count}} altri",
    "cleanButtonTitle": "Rimuovi forzatamente tutti i worktree + branch orfani",
    "removed_one": "✓ {{count}} worktree orfano rimosso.",
    "removed_other": "✓ {{count}} worktree orfani rimossi.",
    "cleanupFailed": "pulizia fallita",
    "lanesHeading": "Worktree",
    "base": "base",
    "isolatedCount_one": "{{count}} isolato",
    "isolatedCount_other": "{{count}} isolati",
    "statusAllocating": "allocazione",
    "statusActive": "attivo",
    "statusCommitting": "commit",
    "statusMerging": "merge",
    "statusMerged": "mergiato",
    "statusConflict": "conflitto",
    "statusFailed": "fallito",
    "conflictBadge": "CONFLITTO",
    "graphAria": "Grafo dei branch worktree da {{base}}",
    "mergedLabel": "✓ mergiato → {{base}}"
  },
  "process": {
    "heading": "Processi in esecuzione",
    "subtitle": "{{active}} attivi · {{total}} totali",
    "killAll": "Termina tutti",
    "emptyTitle": "Nessun processo tracciato",
    "emptyBody": "I processi appaiono qui quando l'agente esegue strumenti bash o exec. I processi attivi mostrano un LED pulsante.",
    "pidLabel": "PID {{pid}}",
    "protected": "protetto",
    "protectedTitle": "Protetto — sopravvive a kill/killAll",
    "killTitle": "Termina PID {{pid}}"
  },
  "diff": {
    "tooLarge": "Diff omesso (file troppo grande per il rendering in linea)."
  },
  "fallback": {
    "placeholder": "Aggiungi un modello di fallback…",
    "emptyHint": "Provati in ordine quando il modello primario è limitato o si blocca.",
    "moveUp": "Sposta su",
    "moveDown": "Sposta giù",
    "manualPlaceholder": "provider/modello",
    "addTitle": "Aggiungi riferimento modello"
  },
  "liveSessions": {
    "loading": "Caricamento sessioni...",
    "apiUnavailable": "API di sessione non disponibile:",
    "empty": "Nessuna sessione live. Apri un'altra istanza wstack per vederla qui.",
    "heading": "Sessioni live ({{count}})",
    "autoRefresh": "aggiornamento automatico ogni 5 s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} iter · {{tools}} strumenti · {{ago}}",
    "andMore": "... e altre {{count}}",
    "noAgents": "Nessun agente"
  },
  "monacoDiff": {
    "applyTitle": "Scrivi la versione modificata sul disco",
    "applying": "Applicazione…",
    "applied": "Applicato",
    "apply": "Applica"
  },
  "errorBody": {
    "showStack_one": "Mostra trace dello stack ({{count}} frame)",
    "showStack_other": "Mostra trace dello stack ({{count}} frame)",
    "hideStack_one": "Nascondi trace dello stack ({{count}} frame)",
    "hideStack_other": "Nascondi trace dello stack ({{count}} frame)"
  },
  "officeMap": {
    "liveHeading": "Live",
    "clients": "Client",
    "agents": "Agenti",
    "model": "Modello",
    "mode": "Modalità",
    "toolCalls": "Chiamate strum.",
    "displayHeading": "Display",
    "statsHud": "HUD stat",
    "legends": "Legende",
    "minimap": "Minimappa",
    "zoomControls": "Controlli zoom",
    "animateWires": "Anima fili",
    "backgroundHeading": "Sfondo",
    "bgDots": "Punti",
    "bgLines": "Linee",
    "bgCross": "Croce",
    "bgNone": "Nessuno"
  },
  "toolInput": {
    "noParams": "(nessun parametro)",
    "itemCount_one": "{{count}} elemento",
    "itemCount_other": "{{count}} elementi",
    "keyCount_one": "{{count}} chiave",
    "keyCount_other": "{{count}} chiavi"
  },
  "message": {
    "roleYou": "Tu",
    "roleTool": "Strumento",
    "roleThinking": "Pensiero",
    "roleAssistant": "Assistente",
    "inputLabel": "Input",
    "downloadTitle": "Scarica come file",
    "empty": "(vuoto)",
    "hideDetails": "Nascondi dettagli",
    "showDetails": "Mostra dettagli",
    "showDetailsLines_one": "Mostra dettagli ({{count}} riga)",
    "showDetailsLines_other": "Mostra dettagli ({{count}} righe)",
    "editHint": "⌘/Ctrl+Invio per salvare · Esc per annullare",
    "saveResend": "Salva e reinvia",
    "thinkingProcess": "Processo di pensiero",
    "thinkingMeta": "iter {{iter}} · {{dur}} · {{lines}}",
    "replay": "replay",
    "linesSuffix_one": "{{count}} riga",
    "linesSuffix_other": "{{count}} righe",
    "copyLog": "Copia log",
    "showFullLog": "Mostra log completo",
    "typing": "Scrive…",
    "noContent": "Nessun contenuto",
    "failedToSend": "⚠ Invio fallito",
    "autoPaused": "⚠️ _Avanzamento automatico in pausa — raggiunto il numero massimo di turni automatici consecutivi. Digita qualcosa per continuare (l'autonomia resta attiva)._",
    "rsIterations": "Iterazioni: {{n}}",
    "rsTools": "Chiamate strum.: {{n}}",
    "rsElapsed": "Trascorso: {{s}}",
    "rsCost": "Costo: {{c}}",
    "useInput": "Input: {{n}}",
    "useOutput": "Output: {{n}}",
    "useCacheRead": "Lettura cache: {{n}}",
    "useCost": "Costo: {{c}}",
    "renderedLabel": "Renderizzato",
    "rawLabel": "Grezzo",
    "showRenderedTitle": "Mostra markdown renderizzato",
    "showRawTitle": "Mostra sorgente markdown grezzo",
    "editTitle": "Modifica e reinvia questo prompt",
    "editLabel": "Modifica",
    "unpinTitle": "Rimuovi pin",
    "pinTitle": "Fissa questa risposta",
    "pinnedLabel": "Fissato",
    "pinLabel": "Fissa",
    "regenerateTitle": "Rigenera questa risposta",
    "retryLabel": "Riprova"
  },
  "watch": {
    "toolFallback": "strumento",
    "toolFailed": "Strumento fallito"
  },
  "shortcuts": {
    "heading": "Scorciatoie da tastiera",
    "footerPre": "Premi",
    "footerPost": "in qualsiasi momento per riaprire questa lista.",
    "sectionGlobal": "Globali",
    "sectionTuiParity": "Parità pannello TUI",
    "sectionFleet": "Flotta & Agenti",
    "sectionChatInput": "Input chat",
    "sectionChat": "Chat",
    "sectionChatNav": "Navigazione chat (senza scrivere)",
    "dCommandPalette": "Apri palette comandi",
    "dShowOverlay": "Mostra questa overlay scorciatoie",
    "dToggleSidebar": "Mostra/nascondi barra laterale",
    "dOpenPanel": "Apri pannello laterale (Sessione, Agenti, Cronologia, File, Changes, Messaggi, Competenze, Office Map)",
    "dDesignStudio": "Apri pannello Design Studio",
    "dWorktrees": "Apri pannello Worktree",
    "dFocusInput": "Focalizza l'input dei messaggi",
    "dSessionPanel": "Pannello sessione",
    "dFleetOverlay": "Overlay monitor flotta",
    "dAgentsOverlay": "Overlay monitor agenti",
    "dWorktreeMonitor": "Monitor worktree",
    "dPlanPanel": "Pannello piano",
    "dTodosPanel": "Pannello attività",
    "dQueuePanel": "Pannello coda",
    "dProcessMonitor": "Monitor processi",
    "dGoalPanel": "Pannello obiettivo",
    "dSessionsDashboard": "Dashboard sessioni",
    "dOfficeMap": "Office map del coordinatore",
    "dDockPicker": "Selettore chip del dock",
    "dOpenFleet": "Apri overlay monitor flotta",
    "dOpenAgents": "Apri overlay monitor agenti",
    "dNavigateAgents": "Naviga gli agenti nel monitor",
    "dSelectAgent": "Seleziona agente focalizzato",
    "dCloseOverlay": "Chiudi overlay attivo",
    "dSendMessage": "Invia messaggio",
    "dNewline": "Inserisci una nuova riga",
    "dRecallPrev": "Riprendi prompt precedente (input vuoto)",
    "dRecallNext": "Riprendi prompt successivo",
    "dSlashPopup": "Apri popup comandi slash",
    "dAutocomplete": "Autocompleta comando evidenziato",
    "dDismissPopup": "Chiudi popup / pulisci input",
    "dSearchChat": "Cerca nella chat attuale",
    "dClearContext": "Pulisci contesto (come /clear)",
    "dNewSession": "Avvia nuova sessione (come /new)",
    "dExportMarkdown": "Esporta chat come markdown",
    "dModelSwitcher": "Overlay selettore modello rapido",
    "dCompactDensity": "Attiva/disattiva densità UI compatta",
    "dAbortRun": "Interrompi run in corso (durante esecuzione)",
    "dFocusNext": "Focalizza messaggio successivo (alias: ↓)",
    "dFocusPrev": "Focalizza messaggio precedente (alias: ↑)",
    "dJumpFirst": "Vai al primo messaggio",
    "dJumpLast": "Vai all'ultimo messaggio",
    "dCopyFocused": "Copia testo messaggio focalizzato",
    "dClearFocused": "Cancella messaggio focalizzato"
  },
  "sddBoard": {
    "titleFallback": "Board SDD live",
    "defaultModelTitle": "Modello worker predefinito a livello di run (gli override per task hanno la precedenza)",
    "graphLabel": "Grafo",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Rimetti ogni attività fallita in pending",
    "retryFailed": "Riprova fallite ({{count}})",
    "resume": "Riprendi",
    "pause": "Pausa",
    "stop": "Ferma",
    "cleanTitle": "Rimuovi i worktree git + branch wstack/ap del run",
    "cleanWorktrees": "Pulisci worktree",
    "rollbackTitle": "Revert di {{count}} commit mergiati su {{base}}",
    "rollback": "Rollback ({{count}})",
    "stopping": "Arresto…",
    "destroying": "Distruzione…",
    "destroyTitle": "Ferma, rimuovi tutti i worktree, revert opzionale dei commit mergiati ed elimina il progetto SDD",
    "destroy": "Distruggi",
    "statDone": "fatti",
    "statRunning": "in corso",
    "statFailed": "falliti",
    "statWave": "ondata",
    "statElapsed": "trascorso",
    "noActiveWorkers": "nessun worker attivo",
    "deadlock": "Stallo — attività bloccate da lavoro fallito:",
    "noRunTitle": "Nessun run SDD attivo.",
    "noRunBody": "Avviane uno dalla procedura New SDD Project o tramite /sdd execute nella CLI — gli agenti appaiono qui live, ciascuno in un worktree isolato.",
    "clickTaskHint": "clicca un'attività per i dettagli",
    "lcClean": "Pulizia",
    "lcRollback": "Rollback",
    "lcDestroy": "Distruzione",
    "lcFailed": "{{op}} fallito: {{reason}}",
    "lcUnknownError": "errore sconosciuto",
    "lcWorktrees_one": "{{count}} worktree rimosso",
    "lcWorktrees_other": "{{count}} worktree rimossi",
    "lcCommits_one": "{{count}} commit revertato",
    "lcCommits_other": "{{count}} commit revertati",
    "lcDeleted": "eliminato {{items}}",
    "lcNothing": "nulla da fare",
    "lcNote": "{{op}}: {{body}} — nota: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Torna all'attività",
    "workingOn": "lavora a questa attività",
    "assigned": "assegnato",
    "metaPriority": "Priorità",
    "metaType": "Tipo",
    "metaDuration": "Durata",
    "metaElapsed": "Trascorso",
    "metaRetries": "Tentativi",
    "metaWorktree": "Worktree",
    "workerModel": "Modello worker",
    "runDefault": "predefinito del run: {{model}}",
    "runDefaultPlaceholder": "Predefinito del run",
    "runDefaultPlaceholderModel": "Predefinito del run ({{model}})",
    "verificationCmd": "Comando di verifica",
    "gatesCompletion": "gating del completamento (exit 0)",
    "verifyPlaceholder": "es. pnpm vitest run path/to/file",
    "addVerify": "+ Aggiungi comando di verifica",
    "description": "Descrizione",
    "timeline": "Cronologia",
    "dependsOn": "Dipende da",
    "blocks": "Blocca",
    "newWorkerPlaceholder": "Nome nuovo worker…",
    "confirmStop": "Fermare questa attività in corso?",
    "confirmDelete": "Eliminare questa attività dal run?",
    "retryTitle": "Rimetti questa attività in pending",
    "reassign": "Riassegna",
    "stopTitle": "Interrompi il worker su questa attività",
    "splitTitle": "Dividi questa attività in sotto-attività delegate a worker separati",
    "split": "Dividi",
    "splitHint": "Una sotto-attività per riga — Titolo :: descrizione (descrizione facoltativa)",
    "splitPlaceholder": "Scrivi il layer dati :: aggiungi il repository\nCollega l'UI",
    "splitInto": "Dividi in sotto-attività",
    "deleteTitle": "Rimuovi questa attività non avviata dal run"
  },
  "sddWizard": {
    "phaseStart": "Avvia",
    "phaseInterview": "Intervista",
    "phaseSpecReview": "Revisione spec",
    "phasePlanning": "Pianificazione",
    "phaseTaskReview": "Revisione attività",
    "phaseRunning": "In corso",
    "phaseDone": "Completato",
    "titleFallback": "Nuovo progetto SDD",
    "questionsSuffix": "{{cur}}/{{max}} domande",
    "tasksSuffix": "{{count}} attività",
    "runCfgTitle": "Config del run — modello predefinito + catena di fallback",
    "modelsLabel": "Modelli",
    "startRun": "Avvia run",
    "defaultWorkerModel": "Modello worker predefinito",
    "leaderDefaultPlaceholder": "Leader / predefinito sessione",
    "useSessionDefault": "Usa predefinito sessione",
    "fallbackChain": "Catena di fallback",
    "appliesToAll": "Si applica a ogni attività. Override per attività dal board live dopo l'avvio.",
    "parallelAgents": "Agenti paralleli",
    "isolateWorktrees": "Isola in worktree git",
    "worktreeOn": "Ogni attività gira nel proprio worktree, squash-mergiato al completamento.",
    "worktreeOff": "Le attività girano direttamente sul branch corrente (nessun isolamento).",
    "goalPrompt": "Cosa vuoi costruire?",
    "goalPlaceholder": "es. Aggiungi login OAuth (Google + GitHub) con gestione sessione",
    "startingInterview": "Avvio intervista…",
    "startInterview": "Avvia intervista",
    "introBody": "Un agente isolato ti intervista per costruire una spec, la scompone in un grafo di attività ordinato per dipendenze, poi una vera flotta multi-agente la esegue — da seguire live sul board.",
    "taskGraphSummary": "Grafo attività · {{count}} attività, ordinate per dipendenze",
    "dragToExplore": "trascina per esplorare",
    "show": "mostra",
    "goalLabel": "Obiettivo",
    "implementationPlan": "Piano di implementazione",
    "approveSpec": "Approva spec → pianifica implementazione",
    "approveTasks": "Approva attività",
    "approvePlan": "Approva piano",
    "answerPlaceholder": "Rispondi alla domanda…",
    "changePlaceholder": "Richiedi una modifica…"
  },
  "fileExplorer": {
    "emptyDir": "vuoto",
    "loadFailed": "Caricamento file fallito: {{error}}",
    "expandAllTitle": "Espandi tutte le cartelle",
    "expandAll": "Espandi tutto",
    "collapseAllTitle": "Comprimi tutte le cartelle",
    "collapse": "Comprimi",
    "folders_one": "{{count}} cartella",
    "folders_other": "{{count}} cartelle",
    "currentDirTitle": "Cartella corrente: {{path}}",
    "navigateToTitle": "Vai a {{path}}",
    "filesSuffix_one": "{{count}} file",
    "filesSuffix_other": "{{count}} file",
    "goToDir": "vai alla cartella",
    "navigateParentTitle": "Vai alla cartella padre di {{path}}",
    "parentDirectory": "cartella padre",
    "noFiles": "Nessun file trovato",
    "copyAbsPath": "Copia percorso assoluto",
    "copyRelPath": "Copia percorso relativo",
    "openInTerminal": "Apri nel terminale",
    "openInFileManager": "Apri nel file manager",
    "mentionInChat": "Menziona in chat",
    "copyPath": "Copia percorso"
  },
  "codeEditor": {
    "sendSelectionAction": "Invia selezione alla chat",
    "noFilesOpen": "Nessun file aperto",
    "selectToEdit": "Seleziona un file dall'esploratore per modificare",
    "sendSelectedTitle": "Invia le righe selezionate alla chat",
    "mentionFileTitle": "Menziona questo file in chat",
    "sendToChat": "Invia alla chat",
    "mentionFile": "Menziona file",
    "loadingEditor": "Caricamento editor…",
    "selectTab": "Seleziona una scheda per vedere il contenuto"
  },
  "analytics": {
    "loading": "Caricamento analytics…",
    "heading": "Dashboard Analytics",
    "autoRefresh": "aggiornamento ogni 10 s",
    "liveSessions": "Sessioni live",
    "agents": "Agenti",
    "agentsActive": "{{count}} attivi",
    "totalEvents": "Eventi totali",
    "categoriesSub": "{{count}} categorie",
    "toolCalls": "Chiamate strum.",
    "iterationsSub": "{{count}} iterazioni",
    "sessionCost": "Costo sessione",
    "tokensSub": "{{input}} in / {{output}} out",
    "sessionDuration": "Durata sessione",
    "messagesSub": "{{count}} messaggi",
    "eventsByCategory": "Eventi per categoria",
    "noEvents": "Nessun evento registrato.",
    "topEvents": "Eventi principali",
    "activeSessionUsage": "Utilizzo sessione attiva",
    "provider": "Provider",
    "model": "Modello",
    "inputTokens": "Token in ingresso",
    "outputTokens": "Token in uscita",
    "cacheRatio": "Rapporto cache",
    "filesRead": "File letti",
    "noSession": "Nessuna sessione attiva o in attesa di dati…",
    "healthErrors": "Salute & errori",
    "errorEvents": "Eventi di errore",
    "warningEvents": "Eventi di avviso",
    "cacheHitRate": "Tasso di hit cache",
    "totalCategories": "Categorie totali",
    "waitingData": "In attesa di dati…",
    "recentEvents": "Eventi recenti",
    "noRecentEvents": "Nessun evento recente. Interagisci con l'UI per generare eventi."
  },
  "promptLib": {
    "searchPlaceholder": "Cerca prompt…",
    "newPrompt": "＋ Nuovo prompt",
    "all": "Tutti",
    "recent": "🕘 Recenti",
    "favorites": "★ Preferiti",
    "noMatch": "Nessun prompt corrisponde.",
    "newPromptHeading": "Nuovo prompt",
    "titlePlaceholder": "Titolo *",
    "descPlaceholder": "Descrizione su una riga",
    "categoryPlaceholder": "Categoria",
    "tagsPlaceholder": "tag, separati, da virgola",
    "contentPlaceholder": "Contenuto del prompt * — usa {{name}} per le variabili",
    "variables": "Variabili",
    "addVar": "＋ var",
    "varNamePlaceholder": "nome",
    "varDescPlaceholder": "descrizione",
    "removeVarTitle": "Rimuovi variabile",
    "required": "obbligatorio",
    "multiline": "multiriga",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Salva prompt",
    "saveFailed": "Impossibile salvare il prompt.",
    "titleContentRequired": "Titolo e contenuto sono obbligatori.",
    "toggleFavoriteTitle": "Toggle preferito",
    "selectOption": "— scegli —",
    "fillMissing": "Compila: {{missing}}",
    "insertIntoChat": "Inserisci nella chat",
    "selectPromptHint": "Seleziona un prompt per anteprima e inserimento."
  },
  "skillDetail": {
    "scopeProject": "Progetto",
    "scopeGlobal": "Globale",
    "scopeBundled": "Incluso",
    "timeoutError": "Timeout della richiesta. Riprova.",
    "updateFailed": "Aggiornamento fallito",
    "saveFailed": "Salvataggio fallito",
    "uninstallFailed": "Disinstallazione fallita",
    "noSkillSelected": "Nessuna competenza selezionata",
    "selectSkillHint": "Seleziona una competenza dalla sidebar per vederne la documentazione",
    "goToChat": "Vai alla chat",
    "openSourceRepo": "Apri repo sorgente",
    "copySourceUrl": "Copia URL sorgente",
    "updatedLabel": "↑ Aggiornato: {{list}}",
    "upToDateLabel": "— Aggiornato: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Cerca aggiornamenti",
    "exportTitle": "Esporta competenza come .md",
    "editTitle": "Modifica competenza",
    "uninstallTitle": "Disinstalla competenza",
    "closeTitle": "Chiudi e vai alla chat",
    "backTitle": "Indietro",
    "forwardTitle": "Avanti",
    "relatedFiles": "File correlati",
    "references": "Riferimenti",
    "goToSkillTitle": "Vai a {{name}}",
    "loadingContent": "Caricamento contenuto…",
    "editingLabel": "Modifica di {{name}}",
    "editStats": "{{lines}} righe · {{words}} parole · {{chars}} caratteri",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Bozza salvata",
    "draftRestored": "Bozza ripristinata",
    "discardDraft": "Scarta bozza",
    "splitViewTitle": "Vista divisa",
    "hidePreviewTitle": "Nascondi anteprima",
    "contentPlaceholder": "Contenuto competenza (markdown)...",
    "loadFailed": "Caricamento contenuto fallito",
    "noContent": "Nessun contenuto disponibile",
    "uninstallSkillHeading": "Disinstalla competenza",
    "uninstallConfirm": "Disinstallare {{name}}?",
    "uninstallRemovePath": "Questo rimuoverà la competenza da {{path}} e non può essere annullato.",
    "uninstallAction": "Disinstalla"
  },
  "office": {
    "sessionStats": "Statistiche sessione",
    "clients": "Client",
    "input": "Ingresso",
    "output": "Uscita",
    "cost": "Costo",
    "agentsSuffix": "agenti",
    "upPrefix": "da {{time}}",
    "webuiClient": "Client WebUI",
    "disconnected": "Disconnesso",
    "connected": "Connesso",
    "tuiClient": "Client TUI",
    "terminal": "Terminale",
    "repl": "REPL",
    "coordinator": "COORDINATORE",
    "fleetSummary": "Riepilogo flotta",
    "toolCallsLabel": "Chiamate strum.",
    "tokensLabel": "Token",
    "coordinatingFleet": "Coordina la flotta",
    "donePrefix": "✓ completato ·",
    "failedPrefix": "✕ fallito ·",
    "seenPrefix": "visto {{time}} fa",
    "availableDesk": "Scrivania libera",
    "mailboxHub": "Hub Posta",
    "unreadSuffix_one": "{{count}} non letto",
    "unreadSuffix_other": "{{count}} non letti",
    "allClear": "Tutto letto",
    "total": "Totale",
    "unreadLabel": "Non letti",
    "liveActivity": "Attività live",
    "waitingActivity": "In attesa di attività…",
    "now": "ora",
    "fleetHq": "QG Flotta WrongStack",
    "live": "LIVE",
    "legendStatus": "Stato",
    "legendActive": "Attivo",
    "legendIdle": "Inattivo",
    "legendError": "Errore",
    "legendConnections": "Connessioni",
    "legendMail": "Posta",
    "legendTask": "Attività",
    "legendStatusConn": "Stato",
    "arrange": "Disponi",
    "arrangeTitle": "Riporta i nodi alla piantina",
    "feed": "Feed",
    "feedTitle": "Mostra/nascondi feed attività live",
    "broadcast": "Trasmetti",
    "broadcastTitle": "Trasmetti un messaggio a ogni sessione live del progetto",
    "broadcastToAll": "Trasmetti a tutte le sessioni",
    "broadcastPlaceholder": "Messaggio a ogni agente live del progetto…",
    "broadcastSendHint": "⌘/Ctrl+Invio per inviare",
    "openFullView": "Apri vista operazioni completa",
    "rowStatus": "Stato",
    "rowModel": "Modello",
    "rowTool": "Strumento",
    "rowIterations": "Iterazioni",
    "rowToolCalls": "Chiamate strum.",
    "rowTokensIn": "Token in",
    "rowTokensOut": "Token out",
    "rowTokensTotal": "Token totali",
    "rowContext": "Contesto",
    "rowCost": "Costo",
    "rowLastSeen": "Ultima volta visto",
    "rowSurface": "Superficie",
    "rowBranch": "Branch",
    "rowPid": "PID",
    "rowDir": "Dir.",
    "rowAgents": "Agenti",
    "rowUptime": "Uptime",
    "rowConnections": "Connessioni",
    "rowTotalMessages": "Messaggi totali",
    "rowUnread": "Non letti",
    "recent": "Recenti",
    "noSubject": "(nessun oggetto)",
    "fullOperationStream": "Flusso operazioni completo",
    "closeEsc": "Chiudi (Esc)",
    "idleDesk": "Scrivania inattiva",
    "fleetHqLabel": "QG Flotta",
    "clientsSuffix_one": "{{count}} client",
    "clientsSuffix_other": "{{count}} client",
    "taskFallback": "attività",
    "controlLabel": "controllo"
  },
  "skillsList": {
    "installTitle": "Installa competenza",
    "createTitle": "Crea competenza",
    "exportTitle": "Esporta tutte le competenze come .zip",
    "checkUpdatesTitle": "Cerca aggiornamenti (tutte)",
    "searchPlaceholder": "Cerca competenze…",
    "loading": "Caricamento…",
    "noSkills": "Nessuna competenza installata",
    "noMatch": "Nessuna competenza corrisponde al filtro",
    "noDescription": "Nessuna descrizione",
    "scopeForeign": "Esterno",
    "installHeading": "Installa Competenza",
    "installHint": "Inserisci un riferimento repo GitHub (owner/repo) o URL completo.",
    "installPlaceholder": "es. wrongstack/skill-name o https://github.com/owner/repo",
    "installScope": "Ambito installazione:",
    "installBtn": "Installa",
    "installedMsg": "Installata: {{names}}",
    "installFailed": "Installazione fallita",
    "createHeading": "Crea Competenza",
    "createHint": "Scaffold una nuova competenza. La prima riga è il trigger.",
    "nameLabel": "Nome",
    "namePlaceholder": "es. mia-nuova-competenza",
    "descLabel": "Descrizione / Trigger",
    "descPlaceholder": "Usa questa competenza quando <situazione>.\nTrigger: l'utente dice \"parola chiave\", \"altra\".",
    "saveIn": "Salva in:",
    "createBtn": "Crea Competenza",
    "createdMsg": "Creata: {{name}}",
    "createFailed": "Creazione fallita"
  },
  "timeline": {
    "noEvents": "Nessun evento."
  },
  "designStudio": {
    "pickHint": "Scegli un kit — l'agent vi si atterrà.",
    "gallery": "Galleria",
    "galleryTitle": "Apri galleria anteprima live",
    "stackTitle": "Stack target",
    "loading": "Caricamento kit…",
    "notFound": "Nessun design kit trovato.",
    "bestFor": "Ideale per:",
    "light": "Chiaro",
    "dark": "Scuro"
  },
  "worktrees": {
    "detached": "(scollegato)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktree",
    "baseSuffix": " · base {{base}}",
    "baseLabel": "base",
    "cleanOrphans": "Pulisci orfani",
    "cleanOrphansTitle": "Rimuovi tutti i worktree orfani",
    "liveBusyTitle": "Un run è attivo — fermalo prima",
    "rescanTitle": "Riscansiona",
    "removed_one": "Rimosso {{count}} worktree.",
    "removed_other": "Rimossi {{count}} worktree.",
    "failed": "Fallito",
    "mergedIntoBase": "{{branch}} unito alla base.",
    "conflictMerge": "Conflitto unendo {{branch}}: {{files}}",
    "seeGit": "vedi git",
    "mergeFailed": "Unione fallita: {{reason}}",
    "unknownReason": "sconosciuto",
    "mergeConfirmTitle": "Unire {{branch}} in {{base}}?",
    "mergeConfirmMsg": "Squash-merge questo branch sul branch base. Si annulla pulitamente in caso di conflitto.",
    "mergeAction": "Unisci",
    "removeConfirmTitle": "Rimuovere {{branch}}?",
    "removeConfirmMsg": "Rimuove forzatamente il checkout del worktree ed elimina il suo branch. Il lavoro non unito viene perso.",
    "empty": "Nessun worktree.",
    "emptyHint": "I run SDD / AutoPhase creano worktree isolati qui. Anche gli orfani dei run crashati appaiono.",
    "actOpenTerm": "Apri nel terminale",
    "actOpenFolder": "Apri cartella",
    "actViewChanges": "Vedi modifiche",
    "actMerge": "Unisci alla base",
    "actRemove": "Rimuovi / scarta",
    "live": "live",
    "noUncommitted": "Nessuna modifica non confermata",
    "commitsAhead_one": "{{count}} commit avanti",
    "commitsAhead_other": "{{count}} commit avanti",
    "more": "…{{count}} altri"
  },
  "officeSettings": {
    "heading": "Mappa Ufficio",
    "headingHint": "Visualizza la tua flotta come piantina d'ufficio con stato agenti live.",
    "statAgents": "Agenti",
    "statMail": "Posta",
    "unreadSuffix": " non letti",
    "sectionView": "Vista",
    "sectionDisplay": "Visualizzazione",
    "sectionBackground": "Sfondo",
    "sectionRecent": "Attività Recente",
    "eventsTrackedSuffix": " eventi tracciati",
    "recentHint": "Invii posta, spawn agenti e cambi di stato appaiono qui.",
    "sectionShortcuts": "Scorciatoie",
    "sectionLegend": "Legenda",
    "hudLabel": "HUD",
    "hudDesc": "Mostra overlay statistiche sessione in tempo reale",
    "hudToggle": "Attiva HUD",
    "minimapLabel": "Minimappa",
    "minimapDesc": "Mostra la minimappa di panoramica",
    "minimapToggle": "Attiva minimappa",
    "controlsLabel": "Controlli",
    "controlsDesc": "Mostra controlli zoom e adatta",
    "controlsToggle": "Attiva controlli",
    "animateLabel": "Anima archi",
    "animateDesc": "Anima il flusso sulle connessioni attive",
    "animateToggle": "Attiva animazione archi",
    "legendLabel": "Mostra legenda",
    "legendDesc": "Mostra legenda di stato e connessione",
    "legendToggle": "Attiva legenda",
    "feedLabel": "Feed live",
    "feedDesc": "Striscia inferiore di attività cross-processo recente",
    "feedToggle": "Attiva feed live",
    "fitView": "Adatta",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci",
    "resetZoom": "Reimposta zoom",
    "legendActive": "Attivo (in corso)",
    "legendIdle": "Inattivo",
    "legendError": "Errore",
    "legendOffline": "Offline",
    "bg": {
      "dots": "Punti",
      "lines": "Linee",
      "cross": "Croce",
      "none": "Nessuno"
    }
  }
}
